<template>
    <div class="container-fluid">
        <div class="row">
            <ProductList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const ProductList = defineAsyncComponent(() => import("@/components/theme/ecommerce/productlist/productlist.vue"))
</script>